<template>
    <div>
        <navbar></navbar>
        <section class="hero is-info is-fullheight">
        <div class="hero-body">
  <div class="container">
    <h1 class="title">
      Industry Financial Statements
    </h1>
    <h2 class="subtitle">
      View Norms and Ratios for Balance Sheets, Income Statements for 400+ Industries
    </h2>
    <div class="boxer">
                         <div class="field is-grouped">
                             <p class="control is-expanded">
                             <button class="button is-primary" @click="signUp">Sign Up!</button>
                             <a class="button is-info" @click="goSampleReports">
                                 View Sample Reports
                             </a>
                                                        </p>
                         </div>
                     </div>
  </div>
</div>
</section>

        </div>
    </div>
</template>

<script>
import Navbar from "./features/Navbar"
import BuyReports from "./BuyReports"
import { REPORT_PARAMETERS } from "../store/actions/report";

export default {
    name: 'Dashboard',
    data() {
        return {
			search: '',
			desc: '',
            books: []
        }
    },
    components: {
        Navbar,
    },
    mounted() {
        this.fetchBooks();
    },
    methods: {
        fetchBooks() {
        },
        signUp() {
        this.$router.push({ name: "Register" });

        },
        goSampleReports() {


                var r = { report:"Standard-1", salestype: "Range",salesexact:"", naics: "213000",   salesrange: "Range-10->$25M-$50M", state: "",     zip: "" }
                this.$store.commit(REPORT_PARAMETERS, r)
                this.$router.push({ name: "ViewReport" }).catch(err => {});

        },
	},
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
.grey-background {
    background-color: hsl(0, 0%, 86%) !important;
}

.hero.is-info {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('../assets/images/hero/restaurant-hero.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue